"use client";

import { SessionProvider } from "next-auth/react";
import { createContext, type ReactNode } from "react";

export const AuthContext = createContext<null>(null);

// Auth.js SessionProvider — PostgreSQL/JWT oturumu client'a buradan akar.
export function AuthProvider({ children }: { children: ReactNode }) {
  return (
    <SessionProvider refetchOnWindowFocus={false}>
      <AuthContext.Provider value={null}>{children}</AuthContext.Provider>
    </SessionProvider>
  );
}
